import script from "./InternalTicketsRequested.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalTicketsRequested.vue?vue&type=script&setup=true&lang=js"

import "./InternalTicketsRequested.vue?vue&type=style&index=0&id=20e9e43b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e9e43b"]])

export default __exports__